/**
 * @file     passwordRules.ts
 * @purpose  The one password length rule shared by every form that sets one.
 */
export const MIN_PASSWORD_LENGTH = 8;
